export default __webpack_public_path__ + "static/media/financial.7ef0fd42.PNG";